import { render, staticRenderFns } from "./TermsDetails.vue?vue&type=template&id=569f376a&scoped=true&"
import script from "./TermsDetails.vue?vue&type=script&lang=js&"
export * from "./TermsDetails.vue?vue&type=script&lang=js&"
import style0 from "./TermsDetails.vue?vue&type=style&index=0&id=569f376a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f376a",
  null
  
)

export default component.exports